import useQuery from '@cbgms/base/http/use-query'
import { useDispatch } from 'react-redux'
import { getWorkorders } from 'app/workorder/state/workorder/actions'

/**
 * useGetWorkordersForSelection will fetch workorders from the API inteneded to be shown in a selection dialog
 * @param vehicleUUID optional filter on wo's for a specific vehicle
 * @returns all orders without a vehicle, or for a specific vehicle
 */
export const useGetWorkordersForSelection = (enabled: boolean, vehicleUUID?: string) => {
  const dispatch = useDispatch()
  return useQuery(
    ['GET', 'WORKORDERS', 'USER-SELECTION-DIALOG', vehicleUUID],
    async () => {
      const result = await dispatch(
        getWorkorders({
          fields: 'Workorder.*',
          page: 1,
          perPage: 200,
          search: vehicleUUID ? `Workorder.VehicleUUID|=|${vehicleUUID}` : 'Vehicle.UUID|ISNULL|',
          orderBy: 'Workorder.CreatedAt|DESC'
        })
      )
      return result.Data
    },
    { enabled }
  )
}

export default useGetWorkordersForSelection
